import axios from "axios";
import { getToken } from "@/utils/auth";
import { Loading } from "element-ui";
import store from "@/store";

// 请求计数器
let activeRequests = 0;
let loadingInstance = null;

// 管理loading状态
const loading = {
  // 显示全局loading
  show() {
    if (!loadingInstance) {
      loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    }
  },
  
  // 隐藏loading
  hide() {
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
  },
  
  // 开始新请求
  start() {
    activeRequests++;
    if (activeRequests === 1) {
      this.show();
    }
  },
  
  // 结束请求
  end() {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests === 0) {
      this.hide();
    }
  }
};

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 显示loading，除非明确跳过
    if (config.skipLoading !== true) {
      loading.start();
    }
    
    // 登录超时判断 - 直接检查 localStorage 中的 token
    const token = getToken();
    if (token) {
      config.headers["userId"] = token;
    } else {
      console.log(window.location.href);
      let url = window.location.href;
      if (url.indexOf("login") < 0) {
        alert("登录超时，请重新登录");
        window.location.href = "/cgxComClient/login";
      }
    }
    
    return config;
  },
  (error) => {
    loading.end();
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 请求完成，减少计数
    if (response.config.skipLoading !== true) {
      loading.end();
    }
    
    const res = response.data;
    if (Number(res.code) === 200) {
      return res;
    }
    return Promise.reject(res);
  },
  (error) => {
    // 错误时也需要减少计数
    if (error.config && error.config.skipLoading !== true) {
      loading.end();
    }
    
    return Promise.reject(error);
  }
);

export default service;
